import React, { useState } from "react";
import StepWizard from "react-step-wizard";
import { ReactComponent as Trophy } from "../img/trophy-icon.svg";

const QuestionStep = ({
  question,
  options,
  correctAnswerIndex,
  nextStep,
  currentStep,
  totalSteps,
  previousStep,
  onAnswer,
}) => {
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isCorrect, setIsCorrect] = useState(null);
  const [canProceed, setCanProceed] = useState(false); // Controla si el botón de "Siguiente" está activado

  const handleOptionChange = (event, index) => {
    setSelectedAnswer(index);
    if (index === correctAnswerIndex) {
      setIsCorrect(true);
      setCanProceed(true); // Habilita el botón de "Siguiente" si la respuesta es correcta
      onAnswer(true); // Notifica que la respuesta es correcta
    } else {
      setIsCorrect(false);
      setCanProceed(false); // Desactiva el botón de "Siguiente" si la respuesta es incorrecta
      onAnswer(false); // Notifica que la respuesta es incorrecta
    }
  };

  return (
    <div>
      <p className="questions-steps">
        Pregunta {currentStep}/{totalSteps - 1}
      </p>
      <h3>{question}</h3>
      {options.map((option, index) => (
        <label
          key={index}
          style={{
            backgroundColor:
              selectedAnswer === index && isCorrect
                ? "#90b6fc" // Fondo azul para respuesta correcta seleccionada
                : selectedAnswer === index && !isCorrect
                ? "#f8d7da" // Fondo rojo para respuesta incorrecta seleccionada
                : "transparent",
            borderColor:
              selectedAnswer === index && isCorrect
                ? "#6197fa"
                : selectedAnswer === index && !isCorrect
                ? "#f5c6cb"
                : "#e3e3e3",
            cursor: selectedAnswer === index ? "default" : "pointer",
            transition: "background-color 0.3s",
            color: selectedAnswer === index && isCorrect ? "#fff" : "#4a4a4a",
          }}
          onMouseEnter={(e) => {
            if (selectedAnswer !== index) {
              e.target.style.backgroundColor = "#f7f7f7"; // Color gris en hover
            }
          }}
          onMouseLeave={(e) => {
            if (selectedAnswer !== index) {
              e.target.style.backgroundColor = "transparent";
            }
          }}
        >
          <input
            type="radio"
            name="answer"
            value={option}
            onChange={(e) => handleOptionChange(e, index)}
            style={{
              accentColor:
                selectedAnswer === index && !isCorrect ? "#f44336" : "", // Rojo para incorrectas
              marginInlineEnd: "10px",
            }}
          />
          {option}
          {selectedAnswer === index && isCorrect && (
            <div className="heart"></div> // Añadir el div heart aquí
          )}
        </label>
      ))}
      {/* Botón para volver al paso anterior */}
      {/* {currentStep > 1 && (
        <button className="back-button" onClick={previousStep} style={{ marginTop: "20px" }}>
          Volver a la pregunta anterior
        </button>
      )} */}
      {/* Botón de siguiente */}
      <button
        className="button is-link"
        onClick={nextStep}
        disabled={!canProceed} // Desactiva el botón hasta que la respuesta sea correcta
      >
        Siguiente
      </button>
    </div>
  );
};

const ResultsSummary = ({ results }) => {
  const totalQuestions = results.length;
  const correctAnswers = results.filter((result) => result).length;
  const percentage = ((correctAnswers / totalQuestions) * 100).toFixed(2);

  return (
    <div className="results-summary" style={{ textAlign: "center", padding: "20px", border: "1px solid #ccc", borderRadius: "10px"}}>
      <h3>Resumen de Resultados</h3>
      <div className="trophy-icon-container">
        <Trophy />
      </div>
      <p style={{ fontSize: "18px", margin: "10px 0" }}>Total de preguntas: 5</p>
      <p style={{ fontSize: "18px", margin: "10px 0" }}>Total de intentos: {totalQuestions}</p>
      <p style={{ fontSize: "18px", margin: "10px 0" }}>Respuestas correctas: {correctAnswers}</p>
      {/* <p style={{ fontSize: "18px", margin: "10px 0" }}>Respuestas incorrectas: {totalQuestions - correctAnswers}</p> */}
      <p style={{ fontSize: "20px", margin: "20px 0", fontWeight: "bold", color: "#4caf50" }}>
        Porcentaje de aciertos: {percentage}%
      </p>
    </div>
  );
};

export function CuestPsicoterapia() {
  const [results, setResults] = useState([]);

  const handleAnswer = (isCorrect) => {
    setResults((prevResults) => [...prevResults, isCorrect]);
  };

  return (
    <>
      <div id="sidebar"></div>
      <div id="main">
        <div id="navigation"></div>
        <div id="detail">
          
          <div className="cuestionario-container">
          {/* <h1>Cuestionario Mejórate. Ayúdanos a optimizar tu tratamiento y observa tu evolución. Completa el cuestionario y OBTÉN 15€ A CAMBIO.</h1> */}
            <StepWizard>
              <QuestionStep
                question="¿Cuál es el objetivo principal de la terapia cognitivo-conductual (TCC)?"
                options={[
                  "Identificar los traumas pasados y analizarlos en profundidad",
                  "Modificar los pensamientos y comportamientos negativos para mejorar el bienestar",
                  "Mejorar la relación con las figuras de autoridad",
                  "Cambiar únicamente el comportamiento sin enfocarse en los pensamientos",
                ]}
                correctAnswerIndex={1}
                onAnswer={handleAnswer}
              />
              <QuestionStep
                question="¿Qué es lo más importante al construir una relación terapéutica efectiva con el psicoterapeuta?"
                options={[
                  "Establecer confianza y una buena comunicación",
                  "Ser lo más reservado posible con tus emociones",
                  "Cumplir siempre con las expectativas del terapeuta",
                  "Hablar solo cuando se te pregunte directamente",
                ]}
                correctAnswerIndex={0}
                onAnswer={handleAnswer}
              />
              <QuestionStep
                question="¿Qué es la terapia de aceptación y compromiso (ACT)?"
                options={[
                  "Una terapia que se enfoca en cambiar directamente los pensamientos negativos",
                  "Una terapia que busca aceptar las emociones difíciles y comprometerse con acciones basadas en valores",
                  "Una terapia que se concentra en el pasado para resolver traumas",
                  "Un enfoque que se basa únicamente en la técnica de relajación profunda",
                ]}
                correctAnswerIndex={1}
                onAnswer={handleAnswer}
              />
              <QuestionStep
                question="¿Cuál de los siguientes es un posible beneficio de la psicoterapia en la rehabilitación?"
                options={[
                  "Ayuda a olvidar los problemas del pasado",
                  "Proporciona herramientas para manejar el estrés y prevenir recaídas",
                  "Cambia automáticamente las relaciones problemáticas",
                  "Garantiza una mejora emocional inmediata",
                ]}
                correctAnswerIndex={1}
                onAnswer={handleAnswer}
              />

              <QuestionStep
                question="¿Qué aspecto es fundamental al trabajar con emociones difíciles en terapia?"
                options={[
                  "Ignorar las emociones negativas para centrarse solo en lo positivo",
                  "Evitar hablar de temas dolorosos hasta estar completamente listo",
                  "Reconocer y aceptar las emociones difíciles sin intentar evitarlas",
                  "Controlar siempre las emociones para no mostrar vulnerabilidad",
                ]}
                correctAnswerIndex={2}
                onAnswer={handleAnswer}
              />

              <QuestionStep
                question="¿Qué son los pensamientos automáticos en la terapia cognitiva?"
                options={[
                  "Son pensamientos irrelevantes que no tienen influencia en la conducta",
                  "Son pensamientos que ocurren de manera espontánea y pueden influir negativamente en las emociones y el comportamiento",
                  "Son pensamientos que siempre son racionales y útiles para la toma de decisiones",
                  "Son recuerdos de experiencias pasadas que no pueden ser modificados",
                ]}
                correctAnswerIndex={1}
                onAnswer={handleAnswer}
              />
              <QuestionStep
                question="¿Qué aspecto clave debes en TCC para comenzar el cambio?"
                options={[
                  "Los pensamientos de los demás sobre tu comportamiento",
                  "Los pensamientos automáticos que afectan a tus emociones y comportamientos",
                  "Las emociones positivas que experimentas con más frecuencia",
                  "Las opiniones de tus seres queridos sobre tus problemas",
                ]}
                correctAnswerIndex={1}
                onAnswer={handleAnswer}
              />

              <QuestionStep
                question="¿Cuál de las siguientes técnicas es común en la terapia cognitivo-conductual (TCC) para manejar la ansiedad?"
                options={[
                  "Evitar por completo las situaciones que generan ansiedad",
                  "Reestructurar pensamientos irracionales para reducir su impacto emocional",
                  "Ignorar los síntomas de ansiedad para evitar que empeoren",
                  "Hablar únicamente sobre las emociones positivas para mejorar el ánimo",
                ]}
                correctAnswerIndex={1}
                onAnswer={handleAnswer}
              />

              <QuestionStep
                question="¿Qué deberías hacer cuando te enfrentas a un pensamiento negativo recurrente sobre ti mismo?"
                options={[
                  "Repetirlo hasta que deje de molestarte",
                  "Ignorarlo y distraerte con otra cosa",
                  "Cuestionarlo y buscar evidencias que lo contradigan",
                  "Aceptar que es verdad y asumir que no cambiará",
                ]}
                correctAnswerIndex={2}
                onAnswer={handleAnswer}
              />

              <QuestionStep
                question="Si sientes que estás empezando a tener pensamientos negativos sobre ti mismo en este proceso, como “nunca voy a mejorar”, ¿qué puedes hacer?"
                options={[
                  "Dejar que el pensamiento siga su curso",
                  "Cuestionar si el pensamiento es realmente cierto y buscar ejemplos que lo contradigan",
                  "Ignorar el pensamiento y continuar tu día",
                  "Aceptar que tal vez es verdad y lidiar con ello más adelante",
                ]}
                correctAnswerIndex={1}
                onAnswer={handleAnswer}
              />

              <QuestionStep
                question="¿Cómo puedes manejar los pensamientos de “solo una vez no me hará daño” durante el proceso de recuperación?"
                options={[
                  "Convencerte de que podrás controlarlo si sucede",
                  "Evitar pensar en ello y distraerte",
                  "Recordar las consecuencias negativas del uso y reemplazar ese pensamiento con uno más realista, como “no vale la pena arriesgar mi progreso”",
                  "Intentar ver lo positivo en esos pensamientos y dejarlos pasar",
                ]}
                correctAnswerIndex={2}
                onAnswer={handleAnswer}
              />
              <QuestionStep
                question="Si te encuentras rodeado de personas que están consumiendo drogas, ¿cuál sería la mejor manera de manejar la situación?"
                options={[
                  "Permanecer con ellos para demostrar que puedes resistir",
                  "Evitar hablar sobre el tema y quedarte",
                  "Apartarte de esa situación y buscar el apoyo de alguien que entienda tu proceso",
                  "Hacer lo que ellos hacen para no sentirte aislado",
                ]}
                correctAnswerIndex={2}
                onAnswer={handleAnswer}
              />

              <QuestionStep
                question="Si tienes un mal día y sientes que no has avanzado lo suficiente en tu proceso de recuperación, ¿cómo podrías manejar esos pensamientos?"
                options={[
                  "Asumir que quizás nunca te recuperarás completamente",
                  "Recordarte que la recuperación tiene altibajos y centrarte en los pequeños logros que has alcanzado",
                  "Comparar tu progreso con el de otras personas para sentirte mejor",
                  "Pensar en dejar el tratamiento si no ves mejoría inmediata",
                ]}
                correctAnswerIndex={1}
                onAnswer={handleAnswer}
              />

              <QuestionStep
                question="¿Qué deberías hacer si te sientes tentado a usar drogas porque crees que te ayudarán a manejar una situación difícil?"
                options={[
                  "Probar una pequeña cantidad para ver si realmente ayuda",
                  "Recordar que las drogas solo empeorarán la situación a largo plazo y usar una estrategia de manejo del estrés",
                  "Esperar hasta sentirte más fuerte para enfrentar la situación sin drogas",
                  "Evitar la situación difícil para no tener que tomar esa decisión",
                ]}
                correctAnswerIndex={1}
                onAnswer={handleAnswer}
              />

              <QuestionStep
                question="¿Qué puedes hacer cuando experimentas un fuerte deseo de consumir pero no hay nadie disponible para apoyarte en ese momento?"
                options={[
                  "Resistir la tentación hasta que encuentres a alguien que te ayude",
                  "Usar una estrategia de TCC, como escribir tus pensamientos y emociones para identificarlos y replantearlos",
                  "Esperar que el deseo desaparezca solo",
                  "Hacer lo que sea necesario para distraerte hasta que pase",
                ]}
                correctAnswerIndex={1}
                onAnswer={handleAnswer}
              />

              <QuestionStep
                question="¿Qué estrategia te ayuda a enfrentar situaciones de estrés sin recurrir a sustancias?"
                options={[
                  "Reprimir lo que sientes",
                  "Practicar la técnica de exposición gradual",
                  "Evitar cualquier situación incómoda",
                  "Aislarte de los demás",
                ]}
                correctAnswerIndex={1}
                onAnswer={handleAnswer}
              />
              <ResultsSummary results={results} />
            </StepWizard>
          </div>
        </div>
      </div>
    </>
  );
}
